window.addEventListener('load', event => {
    const siteFooter = document.getElementById('siteFooter');
    const stateSelector = document.getElementById('stateSelector');
    const footerSiteMapToggle = siteFooter?.querySelector('[data-footer-site-map-toggle]');
    const footerToggles = stateSelector && siteFooter ? stateSelector.querySelectorAll('[data-footer-toggle]') : [];
    const additionalFeatureContentSections = document.querySelectorAll('.content-panel-feature div[data-feature-additional-content]');

    if (footerSiteMapToggle) {
        const textToggleValues = footerSiteMapToggle.getAttribute('data-text-toggle').split(',');
        const initialText = textToggleValues[0];
        footerSiteMapToggle.textContent = initialText;

        footerSiteMapToggle.addEventListener('click', (event) => {
            const currentText = footerSiteMapToggle.textContent;
            const newText = currentText === textToggleValues[0] ? textToggleValues[1] : textToggleValues[0];

            footerSiteMapToggle.textContent = newText;
            siteFooter.dataset.open = siteFooter.dataset.open === 'true' ? 'false' : 'true';
        });
    }

    if (footerToggles.length) {
        for (const footerToggle of footerToggles) {
            const textToggleValues = footerToggle.getAttribute('data-text-toggle').split(',');
            const initialText = textToggleValues[0];
            footerToggle.textContent = initialText;

            footerToggle.addEventListener('click', (event) => {
                const currentText = footerToggle.textContent;
                const newText = currentText === textToggleValues[0] ? textToggleValues[1] : textToggleValues[0];

                stateSelector.dataset.open = stateSelector.dataset.open === 'true' ? 'false' : 'true';

                for (const footerToggler of footerToggles) {
                    footerToggler.textContent = newText;
                }
            });
        }
    }

    for (const additionalFeatureContentSection of additionalFeatureContentSections) {
        const additionalFeatureContentPanel = additionalFeatureContentSection.closest('.content-panel-feature');
        const additionalFeatureContentToggle = additionalFeatureContentPanel?.querySelector('button[data-feature-content-toggle]');

        if (additionalFeatureContentToggle) {
            const textToggleValues = additionalFeatureContentToggle.getAttribute('data-text-toggle').split(',');
            const initialText = textToggleValues[0];
            additionalFeatureContentToggle.textContent = initialText;

            additionalFeatureContentToggle.addEventListener('click', () => {
                const currentText = additionalFeatureContentToggle.textContent;
                const newText = currentText === textToggleValues[0] ? textToggleValues[1] : textToggleValues[0];

                additionalFeatureContentToggle.textContent = newText;

                const isOpening = additionalFeatureContentPanel.dataset.open !== 'true';
                additionalFeatureContentPanel.dataset.open = isOpening ? 'true' : 'false';

                if (isOpening && window.innerWidth < 640) {
                    const siteHeader = document.getElementById('siteHeader');
                    const headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
                    const offsetTop = additionalFeatureContentSection.getBoundingClientRect().top + window.scrollY;

                    window.scrollTo({
                        top: offsetTop - headerHeight - 10,
                        behavior: 'smooth'
                    });
                }
            });
        }
    }



});
